import React, { useEffect, useState } from "react";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { useNavigate } from "react-router-dom";
import { getKitByFilter, GetAllKitStatus, PrintKitApi } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/viewCustomer.css";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import { showInfoToast, showErrorToast } from "../../components/ToastMesg";
import SelectFilter from "../../components/SelectFilter";
import DataGrid from "../../components/DataGrid";

const Kits = () => {
  const navigate = useNavigate();
  const { storeG, companyG, userPermID } = useStateContext();
  const [AllKits, setAllKits] = useState("");
  const [Kit_id, setKit_id] = useState("");
  const [Statuses, setStatuses] = useState([]);
  const [status, setstatus] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const kitsGrid = [
    {
      field: "kit_id",
      headerText: "Kit #",
      minWidth: "100",
      width: "100",
      maxWidth: "110",
      textAlign: "center",
    },
    {
      field: "top_part_no",
      headerText: "Top Part No",
      minWidth: "155",
      width: "155",
      maxWidth: "160",
      textAlign: "left",
    },
    {
      field: "top_part_description",
      headerText: "Top Part Description",
      minWidth: "280",
      width: "360",
      maxWidth: "880",
      textAlign: "left",
    },
    {
      field: "date",
      headerText: "Kit Date",
      type: "date",
      format: "dd/MM/yyyy",
      minWidth: "130",
      width: "135",
      maxWidth: "140",
      textAlign: "Center",
    },
    {
      field: "kit_status",
      headerText: "Kit Status",
      minWidth: "130",
      width: "135",
      maxWidth: "160",
      textAlign: "left",
    },
    {
      field: "so_id",
      headerText: "SO #",
      minWidth: "80",
      width: "80",
      maxWidth: "90",
      textAlign: "center",
    },
    {
      field: `kit_quantity`,
      headerText: "Kit Qty",
      minWidth: "80",
      width: "90",
      maxWidth: "100",
      textAlign: "right",
    },
    {
      field: "complete_date",
      headerText: "Complete Date",
      type: "date",
      format: "dd/MM/yyyy",
      minWidth: "170",
      width: "175",
      maxWidth: "180",
      textAlign: "Center",
    },
  ];

  const handleEditKitClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    if (Kit_id !== "") window.open(`/Kit/UpdateKit/${Kit_id}`, "_blank");
    else showInfoToast("Info!", "Please select kit to edit!");
  };

  const handlePrintClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    if (Kit_id !== "") {
      const resp = await PrintKitApi(Kit_id);
      if (!resp) showErrorToast("Error!", "Record not found!");
    } else showInfoToast("Info!", "Please select Kit to print!");
  };

  const handleViewKitClick = () => {
    TimeoutUtility.resetTimeout();
    if (Kit_id !== "") navigate(`/Kit/ViewKit/${Kit_id}`);
    else showInfoToast("Info!", "Please select kit to view.");
  };

  const handleRowSelected = (args) => setKit_id(args.data.kit_id);

  const handleChangeStatus = (option) => {
    TimeoutUtility.resetTimeout();
    if (option && option.value) setstatus(option);
    else setstatus("select");
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id) {
        setloading(true);
        let sts_id = null;
        let cmp_id = null;
        if (companyG !== null && companyG.company_id !== 0)
          cmp_id = companyG.company_id;
        if (status !== "select" && status !== "Select Status")
          sts_id = status.value;
        trackPromise(
          getKitByFilter(storeG.store_id, cmp_id, sts_id)
            .then((result) => setAllKits(result.data || []))
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [storeG, companyG, status]);

  const handleRefresh = async () => {
    if (storeG?.store_id) {
      let sts_id = null;
      let cmp_id = null;
      if (companyG !== null && companyG.company_id !== 0)
        cmp_id = companyG.company_id;
      if (status !== "select" && status !== "Select Status")
        sts_id = status.value;
      const resp = await getKitByFilter(storeG.store_id, cmp_id, sts_id);
      setAllKits(resp.data || []);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      TimeoutUtility.resetTimeout();
      await GetAllKitStatus()
        .then((resp) => {
          const typeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.k_status_id,
          }));
          setStatuses(typeOptions || []);
        })
        .catch((err) => console.log(err.message));
    };
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Row>
        <Col xl={2} md={3}>
          <Header category="Stock" title="KITS" />
        </Col>
        <Col xl={8} md={6} className="text-center">
          <Header title={companyG.name} />
        </Col>
      </Row>
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          {userPermID.includes(34) && (
            <>
              <Col md="auto p-0">
                <Button text="Update" onClick={handleEditKitClick} />
              </Col>
            </>
          )}
          {userPermID.includes(33) && (
            <Col md="auto p-0">
              <Button text="Print" onClick={handlePrintClick} />
            </Col>
          )}
          <Col md="auto p-0">
            <SelectFilter
              value={status}
              options={Statuses}
              onChange={handleChangeStatus}
              placeholder="Select Status"
            />
          </Col>
        </Row>
      </Container>
      <DataGrid
        loading={loading || promiseInProgress}
        data={AllKits}
        cols={kitsGrid}
        handleRowSelected={handleRowSelected}
        handleDoubleClick={userPermID.includes(33) && handleViewKitClick}
        persistant={false}
        handleRefresh={handleRefresh}
      />
    </div>
  );
};

export default Kits;
